import { apiSlice } from "../stores/base/api-slice";
import { AddContactCompanyInformationRequest, CreditInformationResponse } from "./contract/approval";

const approvalServiceBaseUrl = "/approval/";
const approvalEndpoints = apiSlice.injectEndpoints({
  endpoints: builder => ({
    approveCreditCheck: builder.mutation<any, { creditCheckId: string; isWorthy: string }>({
      query: payload => ({
        url: `${approvalServiceBaseUrl}credit-check/check-worthiness`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["LoanRequest"]
    }),
    getZambiaCustomerCreditInfo: builder.query<CreditInformationResponse, void>({
      query: () => ({
        url: `${approvalServiceBaseUrl}credit-info/ZMB`,
        method: "GET",
      }),
    }),
    saveZambiaBusinessCustomerCreditInfo: builder.mutation<void, FormData>({
      query: payload => ({
        url: `${approvalServiceBaseUrl}credit-info/ZMB/business-owner`,
        method: "POST",
        body: payload,
      }),
    }),
    saveZambiaEmployeeCustomerCreditInfo: builder.mutation<void, FormData>({
      query: payload => ({
        url: `${approvalServiceBaseUrl}credit-info/ZMB/employee`,
        method: "POST",
        body: payload,
      }),
    }),
    saveZambiaEmployeeIdentityInfo: builder.mutation<void, FormData>({
      query: payload => ({
        url: `${approvalServiceBaseUrl}credit-info/ZMB/employee/identity`,
        method: "POST",
        body: payload,
      }),
    }),
    saveZambiaBusinessOwnerContactInfo: builder.mutation<void, AddContactCompanyInformationRequest>({
      query: data => ({
        url: `${approvalServiceBaseUrl}credit-info/ZMB/business-owner/contact`,
        method: "POST",
        body: data,
      }),
    }),
    saveZambiaCreditInfoMeterNumber: builder.mutation<void, { meterNumber?: string }>({
      query: data => ({
        url: `${approvalServiceBaseUrl}credit-info/ZMB/financial`,
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useApproveCreditCheckMutation,
  useLazyGetZambiaCustomerCreditInfoQuery,
  useSaveZambiaBusinessCustomerCreditInfoMutation,
  useSaveZambiaEmployeeCustomerCreditInfoMutation,
  useSaveZambiaEmployeeIdentityInfoMutation,
  useSaveZambiaBusinessOwnerContactInfoMutation,
  useSaveZambiaCreditInfoMeterNumberMutation,
} = approvalEndpoints;
